import { render, staticRenderFns } from "./PS.vue?vue&type=template&id=26f6bbea&scoped=true"
import script from "./PS.vue?vue&type=script&lang=js"
export * from "./PS.vue?vue&type=script&lang=js"
import style0 from "./PS.vue?vue&type=style&index=0&id=26f6bbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f6bbea",
  null
  
)

export default component.exports